<template>
  <div class="circular-chart relative">
    <svg
      class="-rotate-90"
      :width="size"
      :height="size"
      :viewBox="`0 0 ${size + strokeWidth} ${size + strokeWidth}`"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        class="bg-circle"
        cx="50%"
        cy="50%"
        :r="radio"
        :stroke-width="strokeWidth"
      ></circle>
      <circle
        class="progress-circle"
        cx="50%"
        cy="50%"
        :r="radio"
        :stroke-dasharray="`${offset} ${circumference - offset}`"
        :stroke-width="strokeWidth"
      ></circle>
    </svg>
    <div
      class="absolute inset-0 flex flex-col items-center justify-center text-center text-neutral-700 leading-tight"
    >
      <h3>{{ title }}</h3>
      <p>{{ data }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobCircularChart",
  props: {
    percentage: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    data: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 100,
    },
    strokeWidth: {
      type: Number,
      default: 4,
    },
  },
  computed: {
    radio() {
      return this.size / 2;
    },
    circumference() {
      return Math.PI * 2 * this.radio;
    },
    offset() {
      return (this.percentage * this.circumference) / 100;
    },
  },
};
</script>

<style scoped>
.bg-circle {
  fill: none;
  stroke: #d5d5d5;
}

.progress-circle {
  fill: none;
  stroke: #0078ff;
  stroke-linecap: round;
}
</style>
